import { create } from 'zustand';

interface StartupToastState {
  showToast: boolean;
  toastMsg: string;
  toastType: 'positive' | 'negative';
  showStartupToast: (msg: string, type: 'positive' | 'negative') => void;
  hideStartupToast: () => void;
}

const useStartupToastStore = create<StartupToastState>((set) => ({
  showToast: false,
  toastMsg: '',
  toastType: 'positive',
  showStartupToast: (msg, type) => set({ showToast: true, toastMsg: msg, toastType: type }),
  hideStartupToast: () => set({ showToast: false, toastMsg: '' }),
}));

export { useStartupToastStore };